export const BASE_URL = process.env.REACT_APP_API_URL ?? 'https://sbms-services-q666z.ondigitalocean.app/';
export const TIMEOUT = 30000;
export const COPYRIGHT = "\u00A9 Artajasa SIMPONI All Right Reserved 2022";
export const FAQ_URL = process.env.REACT_APP_FAQ_URL ?? `https://sbms-services-q666z.ondigitalocean.app/faq-web/Pendahuluan.html`;
export const MODALACTION = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  VIEW: 'VIEW',
  DOWNLOAD: 'DOWNLOAD'
};

export const RESPONSE = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  INVALID: 'INVALID',
  ADDED: 'ADDED'
};

export const TOKEN_EXPIRED = 'jwt expired';
